/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { XIcon } from "../../../../Basis/FontAwesome";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nEinstellungen";
import { useSchnelleinstiegContext } from "./SchnelleinstiegContext";

type SchrittHeaderProps = {
    children?: React.ReactNode;
};

export default function SchrittHeader(props: SchrittHeaderProps) {
    const { t } = useTranslation();
    const { ueberspringen } = useSchnelleinstiegContext();
    return (
        <Box
            sx={{
                display: "flex",
                mb: 2,
                "& > *": {
                    flexGrow: 1,
                    flexBasis: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                }
            }}
        >
            <div>
                <Box sx={{ transform: "translateX(50%)" }}>
                    {props.children}
                </Box>
            </div>
            <div>
                <IconButton
                    sx={{
                        marginInlineEnd: "22.39px", // korrigiert die falsche Ausrichtung verursacht durch den leeren Tooltip
                        "&:hover": {
                            color: "error.dark",
                        },
                    }}
                    title={t(translationKeys.schnelleinstiegHeader.schliessen)}
                    onClick={ueberspringen}
                >
                    <XIcon />
                </IconButton>
            </div>
        </Box>
    );
}